import { fr } from '../locales/fr';

// Simple nested object retrieval: t('NAV.DASHBOARD') -> "Tableau de Bord"
export function t(key) {
    const keys = key.split('.');
    let value = fr;

    for (const k of keys) {
        if (value && value[k]) {
            value = value[k];
        } else {
            return key; // Fallback to key if not found
        }
    }

    return value;
}
